import React, { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { Flip } from "gsap/Flip";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../components/css/FlipScroll.css";

gsap.registerPlugin(Flip, ScrollTrigger);

export default function FlipScroll() {
  const root = useRef(null);

  useLayoutEffect(() => {
    // gsap.context scopes selectors to this component only
    const ctx = gsap.context(() => {
      let tl;

      const createTimeline = () => {
        // kill old timeline + triggers when recreating on resize
        if (tl) tl.kill();
        ScrollTrigger.getAll().forEach((st) => st.kill());

        const secondState = Flip.getState(".second .marker");
        const thirdState = Flip.getState(".third .marker");
        const fourthState = Flip.getState(".fourth .marker");

        tl = gsap.timeline({
          scrollTrigger: {
            trigger: ".gsapcontainer.initial",
            start: "clamp(top center)",
            endTrigger: ".final",
            end: "clamp(top center)",
            scrub: 1,
            // markers: true,
          },
        });

        tl.add(
          Flip.fit(".box", secondState, {
            ease: "none",
            duration: 1.5,
          })
        );

        tl.add(
          Flip.fit(".box", thirdState, {
            ease: "none",
            duration: 1.5,
          })
        );

        // keep the box parked while scrolling continues
        tl.to({}, { duration: 1.5 });
      };

      createTimeline();

      const onResize = () => createTimeline();
      window.addEventListener("resize", onResize);

      // cleanup for this gsap.context
      return () => {
        window.removeEventListener("resize", onResize);
        if (tl) tl.kill();
        ScrollTrigger.getAll().forEach((st) => st.kill());
      };
    }, root);

    // cleanup when component unmounts
    return () => ctx.revert();
  }, []);

  return (
    <div ref={root}>
      <div className="gsapmain">
        <div className="gsapcontainer initial">
          <div className="box" />
        </div>

        <div className="gsapcontainer second">
          <div className="marker" />
        </div>

        <div className="gsapcontainer third">
          <div className="marker" />
        </div>

        <div className="gsapcontainer fourth">
          <div className="marker" />
        </div>
      </div>

      <div className="final" />
    </div>
  );
}
